import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminCampaigns from "./components/AdminCampaigns";

const AdminBroadcast = () => {
  return (
    <SupportLayout userRole="ADMIN">
      <div className="pb-40">
        <div className="main_container_title_div mb-5 mt-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Broadcast Campaigns
          </h1>
          <p className="text-gray-600 text-xl sm:text-base">
            Create and manage broadcast campaigns across multiple channels
          </p>
        </div>

        <AdminCampaigns type="ONE_OFF" />
      </div>
    </SupportLayout>
  );
};

export default AdminBroadcast;
